import {
    Box,
    Text,
    Image,
    useBreakpointValue,
    Carousel,
    Stack,
    IconButton
} from "@chakra-ui/react"
import { PublicationBlockCarouselPublic } from "../../client"
import { FiChevronLeft, FiChevronRight } from "react-icons/fi"
import { Link } from "@tanstack/react-router"
import { useState } from "react"


const CarouselBlock = ({ data }: { data: PublicationBlockCarouselPublic }) => {
    const slidesPerPage = useBreakpointValue({
        base: 1,
        lg: 1,
        xl: 3,
        "2xl": 4,
    }, { fallback: "base" })


    const [hasInteracted, setHasInteracted] = useState(false)

    return (
        <Box my={10}>
            <Carousel.Root
                mx="auto"
                w="full"
                gap={5}
                loop={true}
                allowMouseDrag
                slideCount={data.fk_carousel_images.length}
                slidesPerPage={slidesPerPage}
                autoplay={hasInteracted ? false : { delay: 4000 }}
                onDragStart={() => setHasInteracted(true)}
                onPointerDown={() => setHasInteracted(true)}
            >
                <Carousel.Control justifyContent="center" gap="4" width="full">
                    <Carousel.PrevTrigger asChild hideBelow="md">
                        <IconButton color="main" bgColor="transparent">
                            <FiChevronLeft width={10} height={10} />
                        </IconButton>
                    </Carousel.PrevTrigger>

                    <Carousel.ItemGroup w="full">
                        {data.fk_carousel_images.map((img, index) => (
                            <Carousel.Item key={index} index={index}>
                                <Stack
                                    gapY="3"
                                    alignItems="center"
                                    w="full"
                                    minW="0"
                                    maxW="100%"
                                >
                                    <Image
                                        src={img.fk_media.path.replace(/-(LG)\./, "-MD.")}
                                        alt={img.fk_media.file_name}
                                        w="full"
                                        h="20em"
                                        objectFit="cover"
                                    />

                                    {img.caption &&
                                        <Text
                                            fontSize={15}
                                            minW="0"
                                            whiteSpace="normal"
                                            wordBreak="break-word"
                                        >
                                            {img.caption}
                                        </Text>
                                    }

                                    {img.fk_author &&
                                        img.fk_author.show_profile ? (
                                            <Link to="/autor/$authorId" params={{ authorId: img.fk_author.id }}>
                                                <Text
                                                    color="main"
                                                    fontSize={15}
                                                    minW="0"
                                                    whiteSpace="normal"
                                                    wordBreak="break-word"
                                                >
                                                    {`Bild: ${img.fk_author.firstname ?? ""} ${img.fk_author.lastname ?? ""} ${img.fk_author.abbreviation ? `(${img.fk_author.abbreviation})` : ""}`}
                                                </Text>
                                            </Link>
                                        ) : (
                                            <Text
                                                color="main"
                                                fontSize={15}
                                                minW="0"
                                                whiteSpace="normal"
                                                wordBreak="break-word"
                                            >
                                                {`Bild: ${img.fk_author?.firstname ?? ""} ${img.fk_author?.lastname ?? ""} ${img.fk_author?.abbreviation ? `(${img.fk_author?.abbreviation})` : ""}`}
                                            </Text>
                                        )
                                    }
                                </Stack>
                            </Carousel.Item>
                        ))}
                    </Carousel.ItemGroup>

                    <Carousel.NextTrigger asChild hideBelow="md">
                        <IconButton color="main" bgColor="transparent">
                            <FiChevronRight width={10} height={10} />
                        </IconButton>
                    </Carousel.NextTrigger>
                </Carousel.Control>

                <Carousel.Indicators />
            </Carousel.Root>
        </Box>
    )
}

export default CarouselBlock